import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Divider from "@mui/material/Divider";
import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";

import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography/Typography";
import { connect, useStore } from "react-redux";
import { setLanguage } from "../../actions/api";
import {
  assignSAE,
  getallsitesareaeqs,
  getsitesareaeqs2,
} from "../../actions/objects";
import avatarExample from "../../assets/user-avatar.svg";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import MenuItemComponent from "./components/MenuItem";
import MenuItemComponentEP from "./components/MenuItemEP";
import { getall } from "../../actions/notification";

import {
  getUserByNodeId,
  resetpassword,
  updateuser,
  updateUserInfo,
} from "../../actions/user";

import {
  Dialog,
  DialogActions,
  DialogContent,
  FormHelperText,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuList,
  Popover,
  Zoom,
} from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import { config_UPTIME } from "../../Constants";
import { generate2Fa } from "../../actions/2fa";
import Circle from "./circle.svg";
import QrCodeLogo from "./img.svg";
import "./profileStyles.css";

import axios from "axios";
import { clsx } from "clsx";
import { getFileExtention, images_enum } from "../../utils/helpers";
import AntDTree from "./AntTree";
import { getItem } from "../../utils/DataProtection";
import {
  useAccountMode,
  withCurrentAccountPrefix,
} from "../../utils/accountMode";

const renderLanguage = "de";
export default connect(
  ({
    isAuthUser,
    isadmin,
    userProfile,
    QrCode,
    twoFaGenerated,
    profiles,
    profileid,
    user,
    allsitesareaseqs,
    subscribedSites,
    subscribedAreas,
    subscribedEquipmentpools,
    subscribedEquipments,
    subscribedSitesNodeIds,
    uiLanguage,
  }) => ({
    isAuthUser,
    isadmin,
    userProfile,
    QrCode,
    twoFaGenerated,
    profiles,
    profileid,
    user,
    allsitesareaseqs,
    subscribedSites,
    subscribedAreas,
    subscribedEquipmentpools,
    subscribedEquipments,
    subscribedSitesNodeIds,
    uiLanguage,
  }),
  {
    assignSAE,
    updateuser,
    updateUserInfo,
    getall,
    generate2Fa,
    resetpassword,
    getUserByNodeId,
    getallsitesareaeqs,
    getsitesareaeqs2,
    setLanguage,
  },
)((props) => {
  const { isFette, prefixPath } = useAccountMode();

  const i18n = useStore().getState().i18n;

  let allSitesData = props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite
    ? props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite
    : [];

  let eqPoolData = props.allsitesareaseqs[0]?.data[0]?.legalentity
    .hasequipmentpool
    ? props.allsitesareaseqs[0]?.data[0]?.legalentity.hasequipmentpool
    : [];

  const [treeInitialValuesEQ, setTreeInitialValuesEQ] = useState([]);
  const [treeInitialValuesEQPOOL, setTreeInitialValuesEQPOOL] = useState([]);

  const [actualPassword, setActualPassword] = useState("");
  const [validationError, setValidationError] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [values, setValues] = React.useState({
    showPassword: false,
    showNewPassword: false,
  });
  const [anchorEquipmentpoolEl, setAnchorEquipmentpoolEl] = React.useState(
    null,
  );
  const [navigate, setNavigate] = useState(false);

  const [Image, setImage] = useState();
  const [givenname, setgivenname] = useState();

  const [details_abteilung, set_details_abteilung] = useState("");
  const [details_kostenstelle, set_details_kostenstelle] = useState("");
  const [details_personal_nummer, set_personal_nummer] = useState("");
  const [details_fachausrichtung, set_details_fachausrichtung] = useState("");
  const [details_comment, set_comment] = useState("");

  const [surname, setsurname] = useState();
  const [email, setemail] = useState();
  const [mobilephone, setmobilephone] = useState();
  const [landlinephone, setlandlinephone] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState(
    props.uiLanguage || "de",
  );
  const store = useStore().getState();
  const [profileid, setProfileId] = useState(props.profileid);
  const [userid, setUserId] = useState(props.user.userid);

  useEffect(() => {
    props.getUserByNodeId({}, "USER");

    props.getallsitesareaeqs("", "ALL_SAE");

    if (Object.keys(props.subscribedEquipments).length) {
      let nodeIds = [];
      for (const [key, value] of Object.entries(props.subscribedEquipments)) {
        nodeIds.push(value.nodeid);
      }
      if (nodeIds.length) {
        props.getall(
          { equipmentnodeids: nodeIds, lang: "de" },
          "ALLNOTIFICATIONS",
        );
      }
    }

    // tree data (sites,area,pools) setup

    let tempInitialValuesEQ = [];
    let tempInitialValuesEQPOOL = [];

    // if (Object.keys(props.subscribedSites).length > 0) {
    //   tempInitialValuesEQ.push(
    //     ...Object.keys(props.subscribedSites).map((key, index) => {
    //       return key;
    //     })
    //   );
    // }

    if (Object.keys(props.subscribedAreas).length > 0) {
      tempInitialValuesEQ.push(
        ...Object.keys(props.subscribedAreas).map((key, index) => {
          return key;
        }),
      );
    }

    // if (Object.keys(props.subscribedEquipments).length > 0) {
    //   tempInitialValuesEQ.push(
    //     ...Object.keys(props.subscribedEquipments).map((key,index) => {
    //       return key;
    //     })
    //   );
    // }

    console.log(props.subscribedEquipmentpools,"props.subscribedEquipmentpools")

    if (Object.keys(props.subscribedEquipmentpools).length > 0) {
      tempInitialValuesEQPOOL.push(
        ...Object.keys(props.subscribedEquipmentpools).map((key, index) => {
          return key;
        }),
      );
    }

    setTreeInitialValuesEQ(tempInitialValuesEQ);
    setTreeInitialValuesEQPOOL(tempInitialValuesEQPOOL);
  }, []);

  // populating data into fields
  useEffect(() => {
    if (props.userProfile.user) {
      setnodeid(props.userProfile?.user?.nodeid);
      setgivenname(props.userProfile.user.givenname);
      setsurname(props.userProfile.user.surname);
      setemail(props.userProfile.user.email);
      setlandlinephone(
        props?.userProfile?.user?.landlinephone?.replace("+49", ""),
      );
      setmobilephone(props?.userProfile?.user?.mobilephone?.replace("+49", ""));
      setImage(
        props.userProfile.user.image &&
          props.userProfile.user?.image?.url != undefined
          ? props.userProfile.user.image.url
          : avatarExample,
      );
      setUserId(props.user.userid);

      if (props.userProfile.user.department !== null) {
        set_details_abteilung(
          props.userProfile.user.department?.[renderLanguage],
        );
      }

      if (props.userProfile.user.professionaltraining !== null) {
        set_details_fachausrichtung(
          props.userProfile.user?.professionaltraining[renderLanguage],
        );
      }

      set_details_kostenstelle(props.userProfile.user?.costcenter);
      set_personal_nummer(props.userProfile.user?.personnelnumber);
      set_comment(props.userProfile.user?.qualification);
      setSelectedLanguage(
        props.userProfile?.userinfo?.contentConfigurations?.language ||
          props.userProfile?.userinfo?.language ||
          props.uiLanguage ||
          "de",
      );
    }
  }, [props.userProfile, props.uiLanguage]);

  const handleEquipmentPoolClick = (event) => {
    setAnchorEquipmentpoolEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEquipmentpoolEl(null);
  };
  //site

  const handleSiteClick = (event) => {};

  const handleSiteClose = () => {};

  const handleClickShowPassword = (name) => {
    setValues({ ...values, [name]: !values[name] });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  /*
   * Styles
   */
  const useStyles = makeStyles()((theme) => ({
    elevatedSection: {
      ...theme.elevatedSection,
    },
    sectionHeader: {
      ...theme.sectionHeader,
    },
    sectionHeadline: {
      marginBottom: 20,
    },
    sectionDivider: {
      margin: "38px -24px",
    },
    sectionDividerBeforeButton: {
      marginBottom: 24,
    },
    inputField: {
      ...theme.inputField,
      ...theme.noMargin.bottom,
    },
    avatarContainer: {
      textAlign: "center",
    },
    avatarEditButton: {
      backgroundColor: theme.palette.white.main,
      boxShadow: "0px 0px 10px 3px rgba(0,0,0,0.2)",
      marginTop: -12,

      "&:hover": {
        backgroundColor: theme.palette.white.main,
        boxShadow: "0px 0px 10px 3px rgba(0,0,0,0.25)",
      },
    },
  }));
  const { classes, cx } = useStyles(props, {
    props: props,
  });

  /* Roles */
  const [role, setRole] = useState("");
  const handleRoleChange = (e) => {
    setRole(e.target.value);
  };

  const [subscribingNodeIds, setsubscribingNodeIds] = useState([]);

  const receiveSubscribingNodeIds = (
    value,
    parentValue,
    checkTypeValue,
    isChecked,
  ) => {
    /*  var arr=subscribingNodeIds
     arr.push(parentValue[value])
     setsubscribingNodeIds(arr) */
    const ok = subscribingNodeIds;
    const obj = {
      parent: parentValue,
      child: value,
      type: checkTypeValue,
      isChecked: isChecked,
    };

    setsubscribingNodeIds((subscribingNodeIds) => [...subscribingNodeIds, obj]);
  };

  const RemoveChild = (value) => {
    // assigning the list to temp variable
    const temp = [...subscribingNodeIds];

    subscribingNodeIds &&
      subscribingNodeIds.map((x, k) => {
        if (x.parent == value) {
          // removing the element using splice
          temp.splice(k, 1);
        }
      });
    // updating the list
    setsubscribingNodeIds(temp);
  };

  const [checkedSites, setcheckedSites] = useState([]);
  const [checkedAreas, setcheckedAreas] = useState([]);
  const receiveCheckedSitesValues = (value) => {
    var arr = checkedSites;
    arr.push(value);
    setcheckedSites(arr);
  };

  /* console.log(checkedSites,"checkedSites"); */

  const receiveCheckedAreasValues = (value) => {
    var arr = checkedAreas;
    arr.push(value);
    setcheckedAreas(arr);
  };

  const [checkedEPools, setcheckedEPools] = useState([]);
  const receiveCheckedEPoolsValues = (value) => {
    var arr = checkedEPools;
    arr.push(value);
    setcheckedEPools(arr);
  };

  const submitForm = async () => {
    const nodeid = JSON.parse(getItem("usernodeid"));
    const storedUserId = getItem("userid");
    const resolvedUserId = storedUserId ? JSON.parse(storedUserId) : userid;
    const obj = {
      objects: subscribingNodeIds,
      usernodeid: nodeid,
    };

    let assignPayload = [];

    treeValuesEQ.map((value) => {
      assignPayload.push({
        nodeid: value,
        isChecked: true,
      });
    });

    treeValuesEQPOOL.map((value) => {
      assignPayload.push({
        nodeid: value,
        isChecked: true,
      });
    });

    // props.assignSAE(obj, "assignSAE");
    props.assignSAE(
      {
        objects: assignPayload,
        usernodeid: JSON.parse(getItem("usernodeid")),
      },
      "assignSAE",
    );

    if (ImageFile != undefined) {
      const url = uploadurl;
      const config = {
        headers: {
          "Content-Type": ImageFile.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      const response = await axios
        .put(url, ImageFile, config)
        .then((res) => {
          //console.log(res.data)
        })
        .catch(function(error) {
          //console.log(error);
        });
      const image = {
        fileid: fileid,
        mimetype: mimetype,
        bucketid: bucketid,
        fileVersion: fileVersion,
      };
      props.updateuser(
        {
          givenname,
          surname,
          mobilephone,
          landlinephone,
          email,
          nodeid,
          image,
          profileid,
          userid,
          actualPassword,
          newPassword,
          department: details_abteilung,
          costcenter: details_kostenstelle,
          personnelnumber: details_personal_nummer,
          professionaltraining: details_fachausrichtung,
          qualification: details_comment,
          lang: selectedLanguage,
        },
        "GETUSER",
      );
      props.setLanguage(selectedLanguage);
      props.updateUserInfo(
        {
          userid: resolvedUserId,
          userinfo: {
            contentConfigurations: {
              language: selectedLanguage,
            },
          },
        },
        "UPDATE_USERINFO_LANGUAGE",
      );
      setNavigate(true);
    } else {
      props.updateuser(
        {
          givenname,
          surname,
          mobilephone,
          landlinephone,
          email,
          nodeid,
          profileid,
          userid,
          actualPassword,
          newPassword,
          department: details_abteilung,
          costcenter: details_kostenstelle,
          personnelnumber: details_personal_nummer,
          professionaltraining: details_fachausrichtung,
          qualification: details_comment,
          lang: selectedLanguage,
        },
        "GETUSER",
      );
      props.setLanguage(selectedLanguage);
      props.updateUserInfo(
        {
          userid: resolvedUserId,
          userinfo: {
            contentConfigurations: {
              language: selectedLanguage,
            },
          },
        },
        "UPDATE_USERINFO_LANGUAGE",
      );
      setNavigate(true);
    }

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, 1500);
  };
  const [ImageFile, setImageFile] = useState();
  const [fileid, setfileid] = useState();
  const [bucketid, setbucketid] = useState();
  const [uploadurl, setuploadurl] = useState();
  const [mimetype, setmimetype] = useState();
  const [nodeid, setnodeid] = useState();
  const [fileVersion, setFileVersion] = useState();

  const [treeValuesEQPOOL, setTreeValuesEQPOOL] = useState([""]);
  const [treeValuesEQ, setTreeValuesEQ] = useState([""]);

  const [isOpen, setIsOpen] = useState(false);

  const handleNewImage = async (e) => {
    e.preventDefault();
    var image = e.target.files[0];
    const exstention = getFileExtention(image?.type);
    if (e.target.files.length > 0) {
      const file = URL.createObjectURL(e.target.files[0]);
      setImage(file);
    }
    setImageFile(image);

    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };
    //const nodeid=uuidv4();
    const prefileid =
      props.userProfile.user.image != null
        ? props.userProfile.user.image.fileid
        : 0;
    let fileid = "";
    if (prefileid != 0) {
      fileid = prefileid;
    }

    const exstension_payload = [
      { nodeid: props.userProfile.user.nodeid, extension: exstention, fileid },
    ];

    const response = await axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config,
      )
      .then((res) => {
        // if (exstention[1] == "png") {
        //   setmimetype('image/png')
        // }
        // else if (exstention[1] == "jpg" || exstention[1] == "jpeg") {
        //   setmimetype('image/jpeg')
        // }
        setmimetype(image.type);
        setfileid(res.data[0].fileid);
        setuploadurl(res.data[0].url);
        setbucketid(res.data[0].bucketid);
        setFileVersion(res.data[0].fileversion);
        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });

    handleCloseAnchoeEl();
    return response;
  };

  const [imageData, setImageData] = useState("");
  const handle2Fa = () => {
    setIsOpen(true);
    /* props.generate2Fa('QrCode') */
    fetchData();
  };

  const handlePasswordValidation = (pass, state) => {
    if (pass === actualPassword || pass === newPassword) {
      setValidationError(true);
      setValidationErrorMessage(
        "Sie können kein zuvor genutztes Passwort nochmal verwenden.",
      );
      return;
    } else {
      setValidationError(false);
      setValidationErrorMessage("");
    }

    if (state === "new") {
      // validate Reges only for NePassword Field
      const reg = new RegExp(
        "(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.{8,}).*$",
      ); // min 8 characters , one uppercase and one lowercase is must
      if (reg.test(pass)) {
        setValidationError(false);
        setValidationErrorMessage("");
      } else {
        setValidationError(true);
        setValidationErrorMessage(
          "Das aktuelle Passwort ist falsch. (mindestens 8 Zeichen, ein Großbuchstabe und ein Kleinbuchstabe sind Pflicht)",
        );
      }
    }
  };

  const fetchData = async () => {
    try {
      const user_token = getItem("user");
      const url = config_UPTIME.url.API_URL + "/2fa/generate";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      });
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result;
        setImageData(dataUrl);
      };
      reader.readAsDataURL(blob);
    } catch (error) {}
  };

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleMobile = (e) => {
    setmobilephone(e.target.value);
  };

  const handleLandLine = (e) => {
    setlandlinephone(e.target.value);
  };
  const handleProfile = (e) => {
    setProfileId(e.target.value);
  };

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
  };

  //

  const [isForgotPassword, setIsForgotPassword] = useState(false);

  const handleForgotPassword = () => {
    setIsForgotPassword(true);
  };

  const handleCloseForgotPassword = () => {
    setIsForgotPassword(false);
  };

  const [input, setinput] = useState({});
  const [errors, seterrors] = useState({});
  const [error, seterror] = useState(false);

  const handleChangeReset = (event) => {
    let Input = input;
    Input[event.target.name] = event.target.value;
    setinput(Input);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (validate()) {
      const body = { email: input["email"] };
      props.resetpassword(body);
      setNavigate(true);
    }
  };

  const validate = () => {
    let Input = input;
    let errors = {};
    let isValid = true;

    if (!input["email"]) {
      isValid = false;
      errors["email"] = "Please enter your email Address.";
      seterror(true);
    }

    if (typeof input["email"] !== "undefined") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!pattern.test(input["email"])) {
        isValid = false;
        errors["email"] = "Please enter valid email address.";
        seterror(true);
      }
    }
    seterrors(errors);

    return isValid;
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchoeEl = () => {
    setAnchorEl(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const makeSelectDataEQPOOL = (getDataForPayload, allSitesNodeIds) => {
    let selectedAreasNodeiDs = [];
    let selectedSitesNodeiDs = [];
    let selectedEquipmentsNodeiDs = [];

    let allNodeIdsforAlleState = [];


    let tempArray = [];
    eqPoolData.map((key) => {
      if (
        getDataForPayload &&
        treeValuesEQPOOL.includes(key.equipmentpool.nodeid)
      ) {
        selectedSitesNodeiDs.push(key.equipmentpool.nodeid);
      }
      allNodeIdsforAlleState.push(key.equipmentpool.nodeid);

      tempArray.push({
        title: key.equipmentpool.name,
        value: key.equipmentpool.nodeid,
        key: key.equipmentpool.nodeid,
        parent_id: 0,
        children: key.equipmentpool.hasequipment
          ? key.equipmentpool.hasequipment.map((hasequipment) => {
              if (
                getDataForPayload &&
                treeValuesEQPOOL.includes(hasequipment.equipment.nodeid)
              ) {
                selectedAreasNodeiDs.push(hasequipment.equipment.nodeid);
              }

              return {
                title: hasequipment.equipment.name[props.uiLanguage]
                  ? hasequipment.equipment.name[props.uiLanguage]
                  : hasequipment.equipment.name
                  ? hasequipment.equipment.name
                  : "",
                checkable: false,
                key: hasequipment.equipment.nodeid,
                value: hasequipment.equipment.nodeid,
                children: hasequipment.equipment?.hasequipment
                  ? hasequipment.equipment?.hasequipment.map((hasequipment) => {
                      if (
                        getDataForPayload &&
                        treeValuesEQPOOL.includes(hasequipment.equipment.nodeid)
                      ) {
                        selectedEquipmentsNodeiDs.push(
                          hasequipment.equipment.nodeid,
                        );
                      }
                      return {
                        title: hasequipment.equipment.name[props.uiLanguage]
                          ? hasequipment.equipment.name[props.uiLanguage]
                          : hasequipment.equipment.name
                          ? hasequipment.equipment.name
                          : "",
                        key: hasequipment.equipment.nodeid,
                        value: hasequipment.equipment.nodeid,
                        children: [],
                        parent_id: hasarea.area.nodeid,
                      };
                    })
                  : [],
              };
            })
          : [],
      });
    });
    return getDataForPayload
      ? {
          selectedSitesNodeiDs: selectedSitesNodeiDs,
          selectedAreasNodeiDs: selectedAreasNodeiDs,
          selectedEquipmentsNodeiDs: selectedEquipmentsNodeiDs,
        }
      : allSitesNodeIds
      ? allNodeIdsforAlleState
      : [...tempArray];
  };

  const makeSelectDataEQ = (getDataForPayload, allSitesNodeIds) => {
    let selectedAreasNodeiDs = [];
    let selectedSitesNodeiDs = [];
    let selectedEquipmentsNodeiDs = [];

    let allNodeIdsforAlleState = [];

    let tempArray = [];
    allSitesData.map((site, key) => {
      if (getDataForPayload && treeValuesEQ.includes(site.site.nodeid)) {
        selectedSitesNodeiDs.push(site.site.nodeid);
      }
      allNodeIdsforAlleState.push(site.site.nodeid);

      tempArray.push({
        title: site.site.name,
        value: site.site.nodeid,
        key: site.site.nodeid,
        parent_id: 0,
        children: site.site.hasarea
          ? site.site.hasarea.map((hasarea) => {
              if (
                getDataForPayload &&
                treeValuesEQ.includes(hasarea.area.nodeid)
              ) {
                selectedAreasNodeiDs.push(hasarea.area.nodeid);
              }

              return {
                title: hasarea.area.name,
                key: hasarea.area.nodeid,
                value: hasarea.area.nodeid,
                parent_id: site.site.nodeid,
                children: hasarea.area?.hasequipment
                  ? hasarea.area?.hasequipment.map((hasequipment) => {
                      if (
                        getDataForPayload &&
                        treeValuesEQ.includes(hasequipment.equipment.nodeid)
                      ) {
                        selectedEquipmentsNodeiDs.push(
                          hasequipment.equipment.nodeid,
                        );
                      }
                      return {
                        title: hasequipment.equipment.name[props.uiLanguage]
                          ? hasequipment.equipment.name[props.uiLanguage]
                          : hasequipment.equipment.name
                          ? hasequipment.equipment.name
                          : "",

                        checkable: false,
                      };
                    })
                  : [],
              };
            })
          : [],
      });
    });
    let dataToReturn = getDataForPayload
      ? {
          selectedSitesNodeiDs: selectedSitesNodeiDs,
          selectedAreasNodeiDs: selectedAreasNodeiDs,
          selectedEquipmentsNodeiDs: selectedEquipmentsNodeiDs,
        }
      : allSitesNodeIds
      ? allNodeIdsforAlleState
      : [...tempArray];
    return dataToReturn;
  };

  const getTreeValuesEQ = (data) => {
    window.hide();
    setTreeValuesEQ(data);
  };

  const getTreeValuesEQPOOL = (data) => {
    window.hide();
    setTreeValuesEQPOOL(data);
  };

  return (
    <>
      <Dialog
        sx={{ backdropFilter: "blur(4px)" }}
        TransitionComponent={Zoom}
        open={isOpen}
        onClose={() => {
          handleCloseDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // style={{ height: 600 }}
      >
        <DialogContent style={{ overflowY: "" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              overflowY: "hidden",
            }}
          >
            <img src={QrCodeLogo} alt="" />
          </div>

          <p className="dialogTitle-profile">
            2-Faktor-Authentifizierung einrichten
          </p>
          <p className="content-profile">
            Bitte scannen Sie den bereitgestellten QR-Code mit der{" "}
            <a
              href="https://support.google.com/accounts/answer/1066447?hl=de&co=GENIE.Platform%3DAndroid&sjid=14104607231448831947-EU"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Authenticator App
            </a>
            , um die Einrichtung der 2-Faktor-Authentifizierung abzuschließen.
          </p>
          <div className="bxShadow QrCode-profile" style={{ marginLeft: 70 }}>
            {imageData && <img src={imageData} alt="Please Scan this QrCode" />}
          </div>

          <Grid
            item
            xs={12}
            className={_s(Theme247.sectionButtonFooter)}
            style={{ justifyContent: "center", marginTop: 20 }}
          >
            <Button
              className="bxShadow"
              variant="contained"
              onClick={handleCloseDialog}
            >
              {i18n.profile.closeWindow}
            </Button>
          </Grid>
        </DialogContent>
        {/* <DialogActions style={{ justifyContent: "space-around" }}>
        <div className='btnWrapper-profile'>
          <Button className='btnCloseDialog-profile' onClick={handleCloseDialog}>
            <p style={{ color: "#FFFFFF" }}>{i18n.profile.closeWindow}</p>
          </Button>
        </div>

      </DialogActions> */}
      </Dialog>

      <Dialog
        sx={{ backdropFilter: "blur(4px)" }}
        TransitionComponent={Zoom}
        open={isForgotPassword}
        onClose={() => {
          handleCloseForgotPassword();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ height: 300 }}
      >
        <DialogContent style={{ overflowY: "", height: 300 }}>
          <form>
            <Typography
              variant="h1"
              className={clsx(classes.formSpacer, classes.headlineSpacer)}
            >
              {i18n.profile.enterValidEmail}
            </Typography>
            <br></br>
            <div>
              <TextField
                id="text-field-profile"
                name="email"
                className={_s(Theme247.inputField)}
                label={i18n.profile.emailLabel}
                value={values.email}
                onChange={(e) => {
                  handleChangeReset(e);
                }}
                variant="outlined"
                helperText={errors.email}
                error={error}
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
            className={classes.loginButton}
          >
            {i18n.profile.reset}
          </Button>
        </DialogActions>
      </Dialog>

      {navigate ? (
        <Navigate push to={withCurrentAccountPrefix(isFette ? "/fette/dashboard" : "/kunden-dashboard")} />
      ) : null}
      <section>
        <Paper
          elevation={Theme247.elevationLow}
          className={classes.elevatedSection}
        >
          <header className={classes.sectionHeader}>
            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item>
                <Typography variant="h1">{i18n.profile.pageTitle}</Typography>
              </Grid>
            </Grid>
          </header>

          <form className={_s(Theme247.form)}>
            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField
                        defaultValue={props.userProfile?.user?.givenname}
                        onChange={(e) => setgivenname(e.target.value)}
                        className={_s(Theme247.inputField)}
                        label={i18n.first_name}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        defaultValue={props.userProfile?.user?.surname}
                        onChange={(e) => setsurname(e.target.value)}
                        className={_s(Theme247.inputField)}
                        label={i18n.last_name}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  {/* for admin */}
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField
                        defaultValue={props.userProfile?.user?.email}
                        onChange={(e) => setemail(e.target.value)}
                        className={_s(Theme247.inputField)}
                        label={i18n.email}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl
                        variant="outlined"
                        className={_s(Theme247.inputField)}
                      >
                        <InputLabel id="role-label">{i18n.role}</InputLabel>
                        {props.profileid === "admin" ? (
                          <Select
                            labelId="role-label"
                            label={i18n.role}
                            defaultValue={profileid}
                            value={profileid}
                            onChange={handleProfile}
                            disabled={true}
                          >
                            {props.profiles ? (
                              props.profiles.map((p, k) => {
                                return (
                                  <MenuItem value={p.id}>
                                    {p.name[renderLanguage]}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem value={""} disabled>
                                {""}
                              </MenuItem>
                            )}
                          </Select>
                        ) : (
                          <Select
                            labelId="role-label"
                            label={i18n.role}
                            defaultValue={profileid}
                            value={profileid}
                            onChange={handleProfile}
                            disabled={true}
                          >
                            {props.profiles ? (
                              props.profiles.map((p, k) => {
                                if (p.id === profileid) {
                                  return (
                                    <MenuItem value={p.id}>
                                      {p.name[renderLanguage]}
                                    </MenuItem>
                                  );
                                }
                              })
                            ) : (
                              <MenuItem value={""} disabled>
                                {""}
                              </MenuItem>
                            )}
                          </Select>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    {
                      <>
                        <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            label={i18n.phone_number_mobile}
                            fullWidth
                            defaultValue={mobilephone}
                            value={mobilephone}
                            onChange={handleMobile}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <em
                                    style={{
                                      color: "#000000",
                                      fontStyle: "normal",
                                    }}
                                  >
                                    +49
                                  </em>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            label={`${i18n.phone_number_landline} (optional)`}
                            fullWidth
                            defaultValue={landlinephone}
                            value={landlinephone}
                            onChange={handleLandLine}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <em
                                    style={{
                                      color: "#000000",
                                      fontStyle: "normal",
                                    }}
                                  >
                                    +49
                                  </em>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      </>
                    }
                  </Grid>

                  <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={6}>
                      <FormControl
                        variant="outlined"
                        className={_s(Theme247.inputField)}
                        fullWidth
                      >
                        <InputLabel id="profile-language-label">
                          {i18n.profile.languageLabel}
                        </InputLabel>
                        <Select
                          labelId="profile-language-label"
                          value={selectedLanguage}
                          onChange={handleLanguageChange}
                          label={i18n.profile.languageLabel}
                        >
                          <MenuItem value="de">
                            {i18n.profile.languageGerman}
                          </MenuItem>
                          <MenuItem value="en">
                            {i18n.profile.languageEnglish}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* for non-admin */}
                </Grid>
              </Grid>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseAnchoeEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Paper sx={{ width: 250, maxWidth: "100%" }}>
                  <MenuList>
                    <label for="myInput">
                      <MenuItem>
                        <ListItemIcon>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 14C6.71667 14 6.47933 13.904 6.288 13.712C6.096 13.5207 6 13.2833 6 13V8H1C0.716667 8 0.479 7.904 0.287 7.712C0.0956668 7.52067 0 7.28333 0 7C0 6.71667 0.0956668 6.479 0.287 6.287C0.479 6.09567 0.716667 6 1 6H6V1C6 0.716667 6.096 0.479 6.288 0.287C6.47933 0.0956668 6.71667 0 7 0C7.28333 0 7.521 0.0956668 7.713 0.287C7.90433 0.479 8 0.716667 8 1V6H13C13.2833 6 13.5207 6.09567 13.712 6.287C13.904 6.479 14 6.71667 14 7C14 7.28333 13.904 7.52067 13.712 7.712C13.5207 7.904 13.2833 8 13 8H8V13C8 13.2833 7.90433 13.5207 7.713 13.712C7.521 13.904 7.28333 14 7 14Z"
                              fill="black"
                              fillOpacity="0.5"
                            />
                          </svg>
                        </ListItemIcon>
                        <ListItemText>
                          {i18n.profile.uploadNewImage}
                        </ListItemText>
                        <ListItemButton>
                          <input
                            id="myInput"
                            style={{ display: "none" }}
                            type={"file"}
                            accept={images_enum}
                            onChange={handleNewImage}
                          />
                        </ListItemButton>
                      </MenuItem>
                    </label>
                  </MenuList>
                  <Divider />
                  {/* <MenuList>
                    <MenuItem>
                      <ListItemIcon>
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3C0.716667 3 0.479 2.90433 0.287 2.713C0.0956668 2.521 0 2.28333 0 2C0 1.71667 0.0956668 1.479 0.287 1.287C0.479 1.09567 0.716667 1 1 1H5C5 0.716667 5.096 0.479 5.288 0.287C5.47933 0.0956666 5.71667 0 6 0H10C10.2833 0 10.521 0.0956666 10.713 0.287C10.9043 0.479 11 0.716667 11 1H15C15.2833 1 15.5207 1.09567 15.712 1.287C15.904 1.479 16 1.71667 16 2C16 2.28333 15.904 2.521 15.712 2.713C15.5207 2.90433 15.2833 3 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM3 3V16H13V3H3ZM8 10.9L9.9 12.8C10.1 12.9833 10.3377 13.075 10.613 13.075C10.8877 13.075 11.1167 12.9833 11.3 12.8C11.5 12.6 11.6 12.3623 11.6 12.087C11.6 11.8123 11.5 11.5833 11.3 11.4L9.4 9.5L11.3 7.6C11.5 7.4 11.6 7.16233 11.6 6.887C11.6 6.61233 11.5 6.38333 11.3 6.2C11.1167 6 10.8877 5.9 10.613 5.9C10.3377 5.9 10.1 6 9.9 6.2L8 8.1L6.1 6.2C5.91667 6 5.68767 5.9 5.413 5.9C5.13767 5.9 4.9 6 4.7 6.2C4.51667 6.38333 4.425 6.61233 4.425 6.887C4.425 7.16233 4.51667 7.4 4.7 7.6L6.6 9.5L4.7 11.4C4.51667 11.5833 4.425 11.8123 4.425 12.087C4.425 12.3623 4.51667 12.6 4.7 12.8C4.9 12.9833 5.13767 13.075 5.413 13.075C5.68767 13.075 5.91667 12.9833 6.1 12.8L8 10.9Z"
                            fill="#FF3D00"
                          />
                        </svg>
                      </ListItemIcon>
                      <ListItemText>{i18n.profile.deletePhoto}</ListItemText>
                    </MenuItem>
                  </MenuList> */}
                </Paper>
              </Popover>

              <Grid item xs={3} className={classes.avatarContainer}>
                <Badge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  badgeContent={
                    <IconButton
                      edge="start"
                      className={classes.avatarEditButton}
                      onClick={handleClick}
                    >
                      {Image !== avatarExample ? (
                        <div>
                          {" "}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_2958_6"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="24"
                              height="24"
                            >
                              <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_2958_6)">
                              <path
                                d="M5 19H6.4L15.025 10.375L13.625 8.975L5 17.6V19ZM19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3043 2.75 17.863 2.75C18.421 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.571 21.275 6.113C21.2917 6.65433 21.1083 7.11667 20.725 7.5L19.3 8.925ZM4 21C3.71667 21 3.47933 20.904 3.288 20.712C3.096 20.5207 3 20.2833 3 20V17.175C3 17.0417 3.025 16.9127 3.075 16.788C3.125 16.6627 3.2 16.55 3.3 16.45L13.6 6.15L17.85 10.4L7.55 20.7C7.45 20.8 7.33767 20.875 7.213 20.925C7.08767 20.975 6.95833 21 6.825 21H4Z"
                                fill="var(--color-primary)"
                              />
                            </g>
                          </svg>
                        </div>
                      ) : (
                        <div>
                          {" "}
                          <label for="myInputFirst">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_2958_839"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_2958_839)">
                                <path
                                  d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6ZM11 16V7.85L8.4 10.45L7 9L12 4L17 9L15.6 10.45L13 7.85V16H11Z"
                                  fill="var(--color-primary)"
                                />
                              </g>
                            </svg>

                            {/* <input
                        id="myInputFirst"
                        style={{ display: 'none' }}
                        type={"file"}
                        accept={images_enum}
                        onChange={handleNewImage}
                      /> */}
                          </label>
                        </div>
                      )}
                    </IconButton>
                  }
                >
                  <Avatar
                    style={{
                      width: "101px",
                      height: "101px",
                    }}
                    src={Image}
                  />
                </Badge>
              </Grid>
            </Grid>

            <Divider className={classes.sectionDivider} />

            {/* details */}

            <Grid
              container
              spacing={6}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <header className={classes.sectionHeader}>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography variant="h1" component="h2">
                        {i18n.profile.additionalDetails}
                      </Typography>
                    </Grid>
                  </Grid>
                </header>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField
                        defaultValue={""}
                        value={details_abteilung}
                        onChange={(e) => set_details_abteilung(e.target.value)}
                        className={_s(Theme247.inputField)}
                        label={i18n.department}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        defaultValue={""}
                        value={details_kostenstelle}
                        onChange={(e) =>
                          set_details_kostenstelle(e.target.value)
                        }
                        className={_s(Theme247.inputField)}
                        label={i18n.cost_center}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  {/* for admin */}
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField
                        defaultValue={""}
                        value={details_personal_nummer}
                        onChange={(e) => set_personal_nummer(e.target.value)}
                        className={_s(Theme247.inputField)}
                        label={i18n.personal_number}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        value={details_fachausrichtung}
                        label={i18n.specialization}
                        defaultValue={details_fachausrichtung}
                        className={_s(Theme247.inputField)}
                        onChange={(e) =>
                          set_details_fachausrichtung(e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    {
                      <>
                        <Grid item xs={12}>
                          <TextField
                            multiline
                            rows="5"
                            value={details_comment}
                            onChange={(e) => {
                              set_comment(e.target.value);
                            }}
                            placeholder={i18n.details_comment}
                            className={_s(Theme247.inputField)}
                            defaultValue={""}
                          />
                        </Grid>
                      </>
                    }
                  </Grid>

                  {/* for non-admin */}
                </Grid>
              </Grid>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseAnchoeEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Paper sx={{ width: 250, maxWidth: "100%" }}>
                  <MenuList>
                    <label for="myInput">
                      <MenuItem>
                        <ListItemIcon>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 14C6.71667 14 6.47933 13.904 6.288 13.712C6.096 13.5207 6 13.2833 6 13V8H1C0.716667 8 0.479 7.904 0.287 7.712C0.0956668 7.52067 0 7.28333 0 7C0 6.71667 0.0956668 6.479 0.287 6.287C0.479 6.09567 0.716667 6 1 6H6V1C6 0.716667 6.096 0.479 6.288 0.287C6.47933 0.0956668 6.71667 0 7 0C7.28333 0 7.521 0.0956668 7.713 0.287C7.90433 0.479 8 0.716667 8 1V6H13C13.2833 6 13.5207 6.09567 13.712 6.287C13.904 6.479 14 6.71667 14 7C14 7.28333 13.904 7.52067 13.712 7.712C13.5207 7.904 13.2833 8 13 8H8V13C8 13.2833 7.90433 13.5207 7.713 13.712C7.521 13.904 7.28333 14 7 14Z"
                              fill="black"
                              fillOpacity="0.5"
                            />
                          </svg>
                        </ListItemIcon>
                        <ListItemText>
                          {i18n.profile.uploadNewImage}
                        </ListItemText>
                        <ListItemButton>
                          <input
                            id="myInput"
                            style={{ display: "none" }}
                            type={"file"}
                            accept={images_enum}
                            onChange={handleNewImage}
                          />
                        </ListItemButton>
                      </MenuItem>
                    </label>
                  </MenuList>
                  <Divider />
                  {/* <MenuList>
                    <MenuItem>
                      <ListItemIcon>
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3C0.716667 3 0.479 2.90433 0.287 2.713C0.0956668 2.521 0 2.28333 0 2C0 1.71667 0.0956668 1.479 0.287 1.287C0.479 1.09567 0.716667 1 1 1H5C5 0.716667 5.096 0.479 5.288 0.287C5.47933 0.0956666 5.71667 0 6 0H10C10.2833 0 10.521 0.0956666 10.713 0.287C10.9043 0.479 11 0.716667 11 1H15C15.2833 1 15.5207 1.09567 15.712 1.287C15.904 1.479 16 1.71667 16 2C16 2.28333 15.904 2.521 15.712 2.713C15.5207 2.90433 15.2833 3 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM3 3V16H13V3H3ZM8 10.9L9.9 12.8C10.1 12.9833 10.3377 13.075 10.613 13.075C10.8877 13.075 11.1167 12.9833 11.3 12.8C11.5 12.6 11.6 12.3623 11.6 12.087C11.6 11.8123 11.5 11.5833 11.3 11.4L9.4 9.5L11.3 7.6C11.5 7.4 11.6 7.16233 11.6 6.887C11.6 6.61233 11.5 6.38333 11.3 6.2C11.1167 6 10.8877 5.9 10.613 5.9C10.3377 5.9 10.1 6 9.9 6.2L8 8.1L6.1 6.2C5.91667 6 5.68767 5.9 5.413 5.9C5.13767 5.9 4.9 6 4.7 6.2C4.51667 6.38333 4.425 6.61233 4.425 6.887C4.425 7.16233 4.51667 7.4 4.7 7.6L6.6 9.5L4.7 11.4C4.51667 11.5833 4.425 11.8123 4.425 12.087C4.425 12.3623 4.51667 12.6 4.7 12.8C4.9 12.9833 5.13767 13.075 5.413 13.075C5.68767 13.075 5.91667 12.9833 6.1 12.8L8 10.9Z"
                            fill="#FF3D00"
                          />
                        </svg>
                      </ListItemIcon>
                      <ListItemText>{i18n.profile.deletePhoto}</ListItemText>
                    </MenuItem>
                  </MenuList> */}
                </Paper>
              </Popover>

              <Grid item xs={3} className={classes.avatarContainer}></Grid>
            </Grid>

            <Divider className={classes.sectionDivider} />

            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <header className={classes.sectionHeader}>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        variant="h1"
                        component="h2"
                        className={clsx(
                          classes.sectionHeadline,
                          _s(Theme247.noMargin.bottom),
                        )}
                      >
                        {i18n.profile.headingSafety}
                      </Typography>
                      <p className={"header2-profile"}>
                        {i18n.profile.passwordSection}
                      </p>
                      <Typography>
                        <p style={{ color: "#00000080" }}>
                          {i18n.profile.passwordDescription}
                        </p>
                      </Typography>
                    </Grid>
                  </Grid>
                </header>

                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <FormControl
                        className={clsx(classes.margin, classes.textField)}
                        variant="outlined"
                      >
                        <InputLabel htmlFor="outlined-adornment-password">
                          {i18n.profile.currentPassword}
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          style={{ width: "100% !important" }}
                          className={clsx(
                            _s(Theme247.inputField),
                            _s(Theme247.noMargin.bottom),
                          )}
                          type={values.showPassword ? "text" : "password"}
                          value={actualPassword}
                          autoComplete="new-password"
                          onChange={(e) => {
                            setActualPassword(e.target.value);
                            handlePasswordValidation(e.target.value, "actual");
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  handleClickShowPassword("showPassword");
                                }}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          labelWidth={70}
                          label={i18n.profile.currentPassword}
                        />
                        <Link
                          to="/reset-password"
                          style={{ marginBottom: 28 }}
                          className={clsx(
                            _s(Theme247.helperText),
                            _s(Theme247.helperTextLink),
                          )}
                        >
                          {i18n.auth.forgotPassword}
                        </Link>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">
                          {i18n.profile.newPassword}
                        </InputLabel>
                        <OutlinedInput
                          style={{ width: "100% !important" }}
                          className={clsx(
                            _s(Theme247.inputField),
                            _s(Theme247.noMargin.bottom),
                          )}
                          type={values.showNewPassword ? "text" : "password"}
                          value={newPassword}
                          placeholder={i18n.profile.newPassword}
                          error={validationError}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            handlePasswordValidation(e.target.value, "new");
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  handleClickShowPassword("showNewPassword");
                                }}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showNewPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          labelWidth={70}
                          label={i18n.profile.newPassword}
                        />
                        {validationError ? (
                          <FormHelperText error id="accountId-error">
                            {validationErrorMessage}
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <header className={classes.sectionHeader}>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <p className={"header2-profile"} style={{ width: 270 }}>
                        {i18n.profile.twoFactorTitle}
                      </p>
                      <Typography>
                        <p style={{ color: "#00000080" }}>
                          {i18n.profile.twoFactorDescription}{" "}
                          <a
                            href="https://support.google.com/accounts/answer/1066447?hl=de&co=GENIE.Platform%3DAndroid&sjid=14104607231448831947-EU"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Google Authenticator App.
                          </a>
                        </p>
                      </Typography>
                      <p style={{ color: "#00000080" }}>
                        {" "}
                        <em style={{ fontStyle: "normal", fontWeight: "bold" }}>
                          Wichtig
                        </em>
                        : {i18n.profile.twoFactorSupportPrefix}{" "}
                        <a href={`mailto:mathias.doebele@247factorynet.com`}>
                          Support
                        </a>{" "}
                        {i18n.profile.twoFactorSupportSuffix}
                      </p>
                    </Grid>
                  </Grid>
                </header>
                {props.twoFaGenerated ? (
                  <div style={{ display: "flex" }}>
                    <img src={Circle} alt="" />
                    <p className="active2Fa">{i18n.profile.twoFactorActive}</p>
                  </div>
                ) : (
                  <div
                    variant="outlined"
                    className="btn2Fa-profile"
                    onClick={handle2Fa}
                  >
                    <p>{i18n.profile.setupNow}</p>
                  </div>
                )}
              </Grid>
            </Grid>
            <br />
            <Divider className={classes.sectionDivider} />

            <Grid
              container
              spacing={6}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <header className={classes.sectionHeader}>
                  {/* <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        variant="h1"
                        component="h2"
                        className={classes.sectionHeadline}
                      >
                        {i18n.profile.assignedEquipment}
                      </Typography>
                      <Typography variant="body1">
                        {
                          "Hier fügen Sie Ihrem Profil Equipments (z.B.Machinen) hinzu, um dieseim Dashboard anzuzeigen und um Push-Nachrichten zu eralten."
                        }
                      </Typography>
                    </Grid>
                  </Grid> */}

                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        variant="h1"
                        component="h2"
                        className={classes.sectionHeadline}
                      >
                        {i18n.profile.assignedEquipment}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ color: "#00000080" }}
                      >
                        {i18n.profile.assignedEquipmentHint}
                      </Typography>
                      {/* <div style={{ display: "flex" }}> */}

                      <p className={"header2-profile"} style={{ width: 270 }}>
                        {i18n.profile.sitesAndAreas}
                      </p>

                      <AntDTree
                        treeData={makeSelectDataEQ(false, false)}
                        getTreeValues={getTreeValuesEQ}
                        initialValues={treeInitialValuesEQ}
                        placeholder={i18n.profile.sitesAndAreas}
                      />

                      <p className={"header2-profile"} style={{ width: 270 }}>
                        {i18n.profile.equipmentPools}
                      </p>

                      <AntDTree
                        treeData={makeSelectDataEQPOOL(false, false)}
                        getTreeValues={getTreeValuesEQPOOL}
                        initialValues={treeInitialValuesEQPOOL}
                        placeholder={i18n.profile.equipmentPools}
                      />
                      {/* </div> */}
                    </Grid>
                  </Grid>
                </header>
                {/* {props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite &&
                  props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
                    (siteItemQ3, key) => {
                      return (
                        <MenuItemComponent
                          key={key}
                          subscribedSitesNodeIds={props.subscribedSitesNodeIds}
                          subscribedAreas={props.subscribedAreas}
                          subscribedEquipments={props.subscribedEquipments}
                          item={siteItemQ3}
                          SitesFromChildToParent={receiveCheckedSitesValues}
                          AreasFromChildToParent={receiveCheckedAreasValues}
                          ReceivesubscribingNodeIds={receiveSubscribingNodeIds}
                          checkedSites={checkedSites}
                          checkedAreas={checkedAreas}
                          subscribingNodeIds={subscribingNodeIds}
                          RemoveChild={RemoveChild}
                        />
                      );
                    }
                  )} */}
              </Grid>
            </Grid>
            {/* 
            <Divider className={classes.sectionDivider} />
            {props.allsitesareaseqs[0]?.data[0]?.legalentity
              ?.hasequipmentpool &&
              props.allsitesareaseqs[0]?.data[0]?.legalentity?.hasequipmentpool?.map(
                (poolItemQ2, key) => {
                  return (
                    <MenuItemComponentEP
                      key={key}
                      subscribedEquipmentpools={props.subscribedEquipmentpools}
                      subscribedEquipments={props.subscribedEquipments}
                      item={poolItemQ2}
                      PoolsFromChildToParent={receiveCheckedEPoolsValues}
                      ReceivesubscribingNodeIds={receiveSubscribingNodeIds}
                      checkedEPools={checkedEPools}
                      subscribingNodeIds={subscribingNodeIds}
                      RemoveChild={RemoveChild}
                    />
                  );
                }
              )} */}

            <Grid
              item
              xs={12}
              className={_s(Theme247.sectionButtonFooter)}
              style={{ justifyContent: "flex-start" }}
            >
              <Button variant="contained" onClick={submitForm}>
                {i18n.button_save_changes}
              </Button>
            </Grid>
          </form>
        </Paper>
      </section>
    </>
  );
});
